module.exports = __webpack_public_path__ + "media/tt.8ed53183.wav";